/**
 * Copyright Aquera Inc 2026
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

export const styles = css`
  :host {
    box-sizing: border-box;
    display: block;
  }

  .group {
    display: flex;
    flex-direction: column;
  }

  .label {
    padding: var(--nile-spacing-xs, var(--ng-spacing-xs)) var(--nile-spacing-xl, var(--ng-spacing-xl));
    font-family: inherit;
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-xs));
    font-weight: var(--nile-font-weight-medium, var(--ng-font-weight-semibold));
    line-height: var(--nile-line-height-1-8, var(--ng-line-height-text-md));
    color: var(--nile-colors-neutral-500, var(--ng-colors-text-placeholder-subtle));
  }
`;

export default [styles];
